import {
  Flex,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useColorModeValue,
} from "@chakra-ui/react";
import { Pagination, Popconfirm, Button } from "antd"; // Button moved here to match usage
import React, { useMemo, useState, useEffect } from "react";
import {
  useGlobalFilter,
  usePagination,
  useSortBy,
  useTable,
} from "react-table";
import { Controller } from "../../../../Controller/Controller";
import { Alert } from "../../../../components/Alert/Alert";

function TransactionTable(props) {
  const [isRefunding, setIsRefunding] = useState(false);

  const { columnsData, tableData, pagination, handlePaginationChange } = props;
  const columns = useMemo(() => columnsData, [columnsData]);
  const data = useMemo(() => tableData, [tableData]);

  const tableInstance = useTable(
    {
      columns,
      data,
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  const { getTableProps, headerGroups } = tableInstance;
  const textColor = useColorModeValue("navy.700", "white");

  // Handle pagination change
  const handlePagination = (page) => {
    if (handlePaginationChange) {
      handlePaginationChange(page);
    }
  };

  const handleRefundPayment = async (transferId) => {
    if (!transferId) return;

    setIsRefunding(true);
    try {
      // اصلاح فراخوانی: memberId ارسال می‌شود، پس office = false است
      const response = await Controller.refundPayment(
        props.memberId,
        false,
        transferId
      );

      if (response.status < 250) {
        Alert.openNotification(
          response.message ? response.message : "Refund processed successfully",
          "success"
        );
        if (props.handleUpdateList) {
          props.handleUpdateList();
        }
      } else {
        const errorMessage =
          response.detail?.[0] || response.message || "Error processing refund";
        Alert.openNotification(errorMessage, "error");
      }
    } catch (err) {
      console.error(err);
      Alert.openNotification("Error", "error");
    } finally {
      setIsRefunding(false);
    }
  };

  useEffect(() => {
    var b = window.location.href;
    localStorage.setItem("viewMember", b.split("/")[b.split("/").length - 1]);
  }, []);

  if (!tableData || tableData.length === 0) {
    return (
      <Flex
        direction="column"
        w="100%"
        align="center"
        justify="center"
        py="20px"
      >
        <Text color={textColor} fontSize="lg" fontWeight="600">
          No transactions available.
        </Text>
      </Flex>
    );
  }

  return (
    <>
      <Flex
        direction="column"
        w="100%"
        overflowX={{ sm: "scroll", lg: "hidden" }}
      >
        <Flex
          align={{ sm: "flex-start", lg: "center" }}
          justify="space-between"
          w="100%"
          px="22px"
          pb="20px"
          mb="10px"
          boxShadow="0px 40px 58px -20px rgba(112, 144, 176, 0.26)"
        >
          <Text color={textColor} fontSize="xl" fontWeight="600">
            Payments
          </Text>
        </Flex>
        <Table {...getTableProps()} variant="simple" color="gray.500">
          <Thead>
            {headerGroups.map((headerGroup, index) => (
              <Tr {...headerGroup.getHeaderGroupProps()} key={index}>
                {columnsData.map((column, colIndex) => (
                  <Th pe="10px" key={colIndex} borderColor="transparent">
                    <Flex
                      justify="space-between"
                      align="center"
                      fontSize={{ sm: "10px", lg: "12px" }}
                      color="gray.400"
                    >
                      {column.Header}
                    </Flex>
                  </Th>
                ))}
              </Tr>
            ))}
          </Thead>

          <Tbody>
            {props.tableData &&
              props.tableData.length > 0 &&
              props.tableData.map((row) => {
                // منطق بررسی وضعیت (مشابه فایل قبلی)
                const status = row.status
                  ? String(row.status).toLowerCase().trim()
                  : "";
                const canRefund =
                  !!row.transfer_id &&
                  (!status || status === "succeeded" || status === "paid");

                return (
                  <Tr key={row.id || Math.random()}>
                    <Td>{row.amount ? row.amount : "-"}</Td>
                    <Td>
                      {row.created
                        ? new Date(row.created)
                            .toISOString()
                            .replace(/T/, " ")
                            .replace(/\.\d+Z$/, "")
                        : "-"}
                    </Td>
                    <Td>{row.currency ? row.currency : "-"}</Td>
                    <Td>{row.description ? row.description : "-"}</Td>
                    <Td>{row.status ? row.status : "-"}</Td>
                    <Td>
                      <Popconfirm
                        title="Refund payment"
                        description="Are you sure you want to refund this payment?"
                        onConfirm={() => handleRefundPayment(row?.transfer_id)}
                        okText="Yes"
                        cancelText="No"
                        disabled={!canRefund || isRefunding}
                      >
                        <Button
                          type="link"
                          danger
                          disabled={!canRefund || isRefunding}
                          loading={
                            isRefunding &&
                            /* Simple check: ideally we track loading per row ID, but global is fine per current logic */ isRefunding
                          }
                        >
                          Refund
                        </Button>
                      </Popconfirm>
                    </Td>
                  </Tr>
                );
              })}
          </Tbody>
        </Table>

        {/* Added Pagination Controls */}
        {pagination && (
          <Flex justify="center" align="center" px="22px" py="10px" w="100%">
            <Pagination
              current={pagination.current}
              pageSize={pagination.pageSize}
              total={pagination.total}
              onChange={handlePagination}
              showSizeChanger={false}
              showQuickJumper={false}
              showTotal={false}
            />
          </Flex>
        )}
      </Flex>
    </>
  );
}

export default TransactionTable;
